import QrCodeContainer from "@components/core/qr-code-container";
import useOneLinkUrl from "hooks/useOneLinkUrl";
import { Trans } from "@lingui/macro";
import { useRouter } from "next/router";
import { useWindowWidth } from "@react-hook/window-size";

const VIDEOS = {
  en: {
    desktop: "/subdomain/why-use-lumi/video-desktop-en.mp4",
    mobile: "/subdomain/why-use-lumi/video-mobile-en.mp4",
  },
  ms: {
    desktop: "/subdomain/why-use-lumi/video-desktop-bm.mp4",
    mobile: "/subdomain/why-use-lumi/video-mobile-bm.mp4",
  },
  zh: {
    desktop: "/subdomain/why-use-lumi/video-desktop-en.mp4",
    mobile: "/subdomain/why-use-lumi/video-mobile-en.mp4",
  },
};

const LandingBottomCta: React.FunctionComponent = () => {
  const { locale } = useRouter();
  const width = useWindowWidth();

  const switchToApp = useOneLinkUrl("https://link.luminews.my/ewC9/landingbtm");

  return (
    <div className="-mx-6 mb-16 bg-white px-6">
      <div className="mx-auto max-w-4xl">
        <div className="mb-16 flex flex-1 flex-col items-center md:mb-40">
          {width && locale && (
            <video autoPlay playsInline loop muted>
              <source
                src={
                  width > 768 ? VIDEOS[locale].desktop : VIDEOS[locale].mobile
                }
                type="video/mp4"
              />
            </video>
          )}
          <div className="mt-16 text-[31px] md:mt-40 md:text-[39px]">⚡️</div>
          <p className="px-6 text-center font-poppins text-[31px] font-bold text-primary md:text-[39px]">
            <Trans>All in one fast, smooth app!</Trans>
          </p>
          <Trans>
            <p className="px-6 text-center font-poppins text-text-darkest">
              Download the Lumi News app for free on Google Play Store, Apple
              App Store, and Hauwei AppGallery.
            </p>
          </Trans>
          <div className="mt-8 md:hidden">
            <a href={switchToApp}>
              <a className="mb-4 flex justify-center rounded-2xl bg-primary py-3 px-8 font-sen text-white">
                <Trans>Free Download 🎉</Trans>
              </a>
            </a>
          </div>
          <div className="mt-8 hidden w-80 sm:block">
            <QrCodeContainer
              size="medium"
              text={<Trans>Scan to download the Lumi News app</Trans>}
              initialUrl="https://link.luminews.my/ewC9/landingbtm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingBottomCta;
